













































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { masterModule } from '@/store/modules/entities/master.module';
import GJgrowEventCreateConfirmView from '@/views/GJgrowEventCreate/ConfirmView/GJgrowEventCreateConfirmView.vue';
import GJgrowEventDetailProgress from '@/views/GJgrowEventDetail/GJgrowEventDetailProgress.vue';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity } from '@/models/activity/activity';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { GEnum } from '@/constants/enum.defination';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { GPageBase } from '@/mixins';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { jgrowEventProgressModule } from '@/store/modules/frames/jgrow-event-progress.module';
import { SchoolClass } from '@/models/school-class/school-class';
import { Event } from '@/models/jgrow/event';

@Component({
  name: 'GJgrowEventDetail',
  components: {
    GTitleBar,
    GCustomBreadCrumb,
    GJgrowEventCreateConfirmView,
    GJgrowEventDetailProgress,
  },
  computed: {},
  methods: {},
})
export default class GJgrowEventDetail extends mixins(GPageBase) {
  eventID: number = 0; // クエリパラメータから取得した受検コースID
  breadCrumbItems: BreadCrumbElement[] = []; // パンくずリスト
  lazy: boolean = false; // 遅延描画用(リソース取得後にmount)
  isModal: boolean = false; // 受検未割り当て者の更新を促すダイアログ

  created() {
    // 対象のイベントID
    this.eventID = Number(this.$route.params['eventID']);
    // イベント詳細ページであることを保持しておく
    jgrowEventCreateModule.setMode(GEnum.JgrowEventPageMode.Detail);
  }
  async mounted() {
    // データクリア
    jgrowEventCreateModule.clean();

    // マスタデータの取得
    await masterModule.fetchQuestionType();
    await masterModule.fetchAllQuestionType();
    masterModule.fetchCompetency();
    masterModule.fetchDestinations();
    await activityModule.fetchActivities();
    // 受検設定周りの情報取得
    await schoolClassModule.fetchGrades();
    await schoolClassModule.fetchSchoolClasses();
    await schoolClassModule.fetchGradesSchoolClasses();

    // イベント情報取得（URLのイベントIDをキーに取得）
    await jgrowEventCreateModule.fetchEvent(this.eventID);
    // 保持した作成済みイベント情報から、イベント作成・編集用データへのコピー
    jgrowEventCreateModule.setEventParam();

    // イベント進捗データの取得
    await jgrowEventProgressModule.fetchEventProgress(this.eventID);

    this.breadCrumbItems = [
      { title: 'ホーム', icon: 'ios-home', routerPath: '/pages/home' },
      { title: '受検一覧・作成', routerPath: '/pages/exam/list' },
      { title: `受検詳細【${this.createdEventName}】` },
    ];

    // 全てのアクティビティを保持
    jgrowEventCreateModule.setActivitySelections(activityModule.activities.filter((act: Activity) => act)); // デフォルトは全てのアクティビティ
    // 選択済みのアクティビティをセット
    jgrowEventCreateModule.setActivitySelected(jgrowEventCreateModule.createdEvent.activities.map((actID: number) => activityModule.toActivity(actID)));

    jgrowEventCreateModule.setCompetencySelections(jgrowEventCreateModule.createdEvent.competencies.map((competencyID: number) => masterModule.toCompetency(competencyID)));
    // クラスID が存在する場合、クラス単位での選択
    if (jgrowEventCreateModule.createdEvent.schoolClassIDs.length > 0) {
      jgrowEventCreateModule.setSchoolClassSelection(schoolClassModule.schoolClasses.filter((sc: SchoolClass) => jgrowEventCreateModule.createdEvent.schoolClassIDs.includes(sc.schoolClassID))); // クラスID を元に スクールクラスを設定
      schoolClassModule.setGradeSchoolClassesIncludeSelected(
        schoolClassModule.schoolClasses.filter((sc: SchoolClass) => jgrowEventCreateModule.createdEvent.schoolClassIDs.includes(sc.schoolClassID))
      ); //学年クラスデータにチェックボックスグループの値を反映
      jgrowEventCreateModule.setExamnieeSelectionType(GEnum.ExamineeSelectionType.Class);
    } else {
      // 生徒単位での選択の場合
      jgrowEventCreateModule.setAlreadyAssignedStudentIDs(jgrowEventCreateModule.createdEvent.students);
      jgrowEventCreateModule.setExamnieeSelectionType(GEnum.ExamineeSelectionType.Student);
    }

    // クラス編成によりクラスに生徒が追加された場合はモーダルを起動
    this.isModal = jgrowEventProgressModule.noAssignedExamineeCount > 0;

    this.lazy = true;
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get eventData(): Event {
    return jgrowEventCreateModule.createdEvent;
  }

  get createdEventName(): string {
    return jgrowEventCreateModule.createdEvent.eventName;
  }

  get isEditable(): boolean {
    return this.eventData.isEditable();
  }

  get noAssignedExamineeCount(): number {
    return jgrowEventProgressModule.noAssignedExamineeCount;
  }

  handleUpdateExamineeStudents() {
    this.loadingPage(
      () => {
        jgrowEventProgressModule.updateExamineeStudents(this.eventID);
      },
      () => {
        this.showNotice(GEnum.MessageType.Success, `イベント【${this.createdEventName}】`, `受検者情報を更新しました`);
        this.isModal = false;
      }
    );
  }

  handleGotoEventEdit() {
    this.$router.push(`/pages/jgrow/event/create?mode=${GEnum.JgrowEventPageMode.Edit}&eventID=${this.eventID}`);
  }
}
